import React, { Component } from 'react'
import { translate } from 'react-i18next'
import { func, object } from 'prop-types'
import { Input } from '../ui/inputs/Input'
import { validationAccount } from './validators'
import { stores, view } from '../../stores'
import { Loader } from '../ui/states/Loader'
import { PhoneInput } from '../ui/inputs/PhoneInput'
import { IntToStringOrDefault } from '../../utilities/numbers'
import { CheckBox } from '../ui/inputs/CheckBox'
import { CountryInput } from '../ui/inputs/CountryInput'
import { Birthdate } from '../ui/inputs/Birthdate'
import { validateReferences } from '../../utilities/validators'
import { PasswordConfirmationModal } from '../modals/PasswordConfirmationModal'
import { getErrorTranslation } from '../../utilities/errors'
import { PagesPaths } from '../../constants/Pages'
import { withRouter } from 'react-router'

class AccountEditComponent extends Component {
  constructor () {
    super()
    this.state = {
      error: '',
      newPassword: '',
      confirmationModal: false
    }
  }

  validate () {
    const { isValid } = validateReferences(this.refs)
    const { t } = this.props
    if (!isValid) {
      this.setState({ error: t('common:fields:incomplete_form') })
    } else {
      this.setState({ error: '' })
    }
    return isValid
  }

  update (key, store = stores.account.update) {
    return (value) => {
      store[key] = value
    }
  }

  /**
   * Some fields should require password confirmation
   * @returns boolean
   */
  shouldAskConfirmation () {
    return (
      stores.account.connected.email !== stores.account.update.email ||
      this.state.newPassword !== ''
    )
  }

  async submit (password) {
    const { t, history } = this.props
    if (this.shouldAskConfirmation() && !password) {
      return this.setState({ confirmationModal: true })
    }

    try {
      const newPassword = this.state.newPassword
      const email = stores.account.update.email

      // Update account
      await stores.account.updateAccount({ password, newPassword: newPassword || null })
      history.push(PagesPaths.ACCOUNT.path)

      // Authenticate
      if (newPassword) {
        const rememberMe = stores.authentication.token.rememberMe
        stores.authentication.email = email
        await stores.authentication.authenticate({ password: newPassword, rememberMe })
      }
    } catch (e) {
      return this.setState({ error: getErrorTranslation(t, e) })
    }
  }

  render () {
    const { t } = this.props
    const store = stores.account.update

    if (!store) {
      return (<Loader size='medium' />)
    }

    return (
      <div>
        <Input value={store.lastName} onChange={this.update('lastName')} ref='lastName' label={t('common:fields:lastname')} name='lastName' type='text' rules={validationAccount.lastName} />
        <Input value={store.firstName} onChange={this.update('firstName')} ref='firstName' label={t('common:fields:firstname')} name='firstName' type='text' rules={validationAccount.firstName} />
        <Input value={store.address.address} onChange={this.update('address', store.address)} ref='address' label={t('common:fields:adress')} name='address' type='text' rules={validationAccount.address} />
        <Input value={store.address.zipCode} onChange={this.update('zipCode', store.address)} ref='zipcode' label={t('common:fields:zip_code')} name='zipcode' type='text' rules={validationAccount.zipCode} />
        <Input value={store.address.city} onChange={this.update('city', store.address)} ref='city' label={t('common:fields:city')} name='city' type='text' rules={validationAccount.city} />
        <PhoneInput value={store.phone} onChange={this.update('phone')} ref='phone' label={t('common:fields:phone')} name='phone' type='text' rules={validationAccount.phone} required />
        <Input value={store.email} onChange={this.update('email')} ref='email' label={t('common:fields:email')} name='email' type='text' rules={validationAccount.email} />
        <Input value={IntToStringOrDefault(store.gardenSurface, 0)} onChange={this.update('gardenSurface')} ref='surface' label={t('common:fields:surface')} name='surface' type='number' rules={validationAccount.gardenSurface} />
        <Birthdate value={store.birthdate} onChange={this.update('birthdate')} ref='birthdate' label={t('common:fields:birthdate')} name='birthdate' type='text' rules={validationAccount.birthdate} />
        <CountryInput value={store.country} onChange={this.update('country')} ref='country' label={t('common:fields:country')} name='country' />
        <CountryInput value={store.nationality} onChange={this.update('nationality')} ref='nationality' label={t('common:fields:nationality')} name='nationality' />
        <Input value={this.state.newPassword} onChange={(value) => this.setState({ newPassword: value })} ref='newPassword' label={t('common:fields:newPassword')} name='newPassword' type='password' rules={validationAccount.password} />
        <Input ref='confirm' associated={() => this.refs['newPassword'].state} label={t('common:fields:confirm')} name='passwordConfirm' type='password' rules={validationAccount.passwordConfirm} />
        <div className='account__edit__notif'>
          <h2 style={{fontWeight: '500'}}>{t('common:account:parameters')}</h2>
          <CheckBox style={{'marginBottom': '1em'}} checked={store.notifications} onChange={this.update('notifications')} ref='notifications' label={t('common:fields:authorize_notif')} name='notifications' />
          <CheckBox checked={store.sms} onChange={this.update('sms')} ref='sms' label={t('common:fields:authorize_sms')} name='sms' />
        </div>
        <button
          style={{ marginTop: '30px' }}
          onClick={() => this.validate() && this.submit()}
          className='btn--green layout--centered'>{t('common:buttons:save')}</button>
        { this.state && this.state.error !== '' && <p className='form__errormessage' style={{ textAlign: 'center' }}>{this.state.error}</p> }
        <PasswordConfirmationModal
          isOpen={this.state.confirmationModal}
          handleClose={() => this.setState({ confirmationModal: false })}
          onAuthenticated={(password) => this.validate() && this.submit(password)}
        />
      </div>
    )
  }
}

AccountEditComponent.propTypes = {
  t: func,
  history: object
}

export const AccountEdit = withRouter(translate()(view(AccountEditComponent)))



// WEBPACK FOOTER //
// ./src/components/customer/AccountEdit.js